import { render, staticRenderFns } from "./address-select.vue?vue&type=template&id=68a7ee16&scoped=true&"
import script from "./address-select.vue?vue&type=script&lang=js&"
export * from "./address-select.vue?vue&type=script&lang=js&"
import style0 from "./address-select.vue?vue&type=style&index=0&id=68a7ee16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7ee16",
  null
  
)

export default component.exports